import { AnyAction } from 'redux';
import { Appearance } from '@/types';
import { getPossiblePrintTypes } from '@/model/configuration/getPossiblePrintTypes';
import { getConfigurations } from '@/model/draft/getConfigurations';
import { appearanceSwitchModalAction } from '@/redux/modal/actions/appearanceSwitchModalAction';
import { dismissModalAction } from '@/redux/modal/actions/dismissModalAction';
import { Thunk } from '@/redux/types';
import { switchAppearanceAction } from '@/components/draft/draftState/actions/switchAppearanceAction';

export const switchAppearanceWithConfirmationAction =
  (appearance: Appearance, removeConfigurations?: boolean): Thunk<void, AnyAction> =>
  async (dispatch, getState) => {
    const switchAppearance = () => {
      getState().draftDispatch(switchAppearanceAction(appearance));
      dispatch(dismissModalAction);
    };

    const unprintableConfigurations = getConfigurations(getState().draft).filter(
      (configuration) =>
        getPossiblePrintTypes(configuration, configuration.printArea, appearance).length === 0
    );
    if (unprintableConfigurations.length && !removeConfigurations) {
      dispatch(
        appearanceSwitchModalAction(
          unprintableConfigurations.map((c) => c.cid),
          switchAppearance
        )
      );
      return;
    }

    switchAppearance();
  };
